<div nz-row class="MessageDetailContainer" *ngIf="!isLoading">
  <div nz-col nzSpan="24" class="headerSection">
    <nz-page-header class="site-page-header">
      <nz-page-header-title>
        {{ MessageDetail.Subject }}
      </nz-page-header-title>
      <nz-page-header-extra>
        <button nz-button nz-dropdown nzTrigger="click" [nzDropdownMenu]="menu">
          <i nz-icon nzType="folder-open" nzTheme="outline"></i>
          Move To
        </button>
        <nz-dropdown-menu #menu="nzDropdownMenu">
          <ul nz-menu>
            <li
              nz-menu-item
              *ngFor="let folder of Folders"
              (click)="MoveMessage(messageId, folder.Code)"
            >
              <i class="fa {{ folder.Icon }}"></i> {{ folder.Name }}
            </li>
          </ul>
        </nz-dropdown-menu>

        <button
          nz-button
          nzType="default"
          [routerLink]="['/apps/crm/inbox/Compose']"
          [queryParams]="{ replyCode: messageId }"
        >
          <i class="fas fa-reply" style="font-size: smaller"></i>
          Reply
        </button>
        <!-- <button nz-button nzType="primary">Primary</button> -->
      </nz-page-header-extra>
      <nz-page-header-content>
        <nz-tag [nzColor]="'blue'">
          <span>{{
            removeDateAddedString(MessageDetail.ReceivedDate) | date
          }}</span>
          -
          <span>{{
            removeDateAddedString(MessageDetail.ReceivedTime)
              | date : "shortTime"
          }}</span>
        </nz-tag>
        <span>
          From:<b> {{ MessageDetail.UserSignName }}</b>
        </span>
      </nz-page-header-content>
    </nz-page-header>
  </div>
  <div innerHtml="{{ MessageDetail.UserText }}" style="margin: 15px"></div>
  <div
    nz-col
    nzSpan="24"
    class="TableSection"
    *ngIf="MessageDetail.MsgColValues.length > 0"
  >
    <nz-table #basicTable [nzData]="RecordsArray" [nzScroll]="{ y: '500px' }">
      <thead>
        <tr>
          <th nzWidth="100px">#</th>
          <th *ngFor="let column of columns">
            {{ column }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of basicTable.data">
          <td>{{ data + 1 }}</td>
          <td *ngFor="let item of MessageDetail.MsgColValues">
            <a
              *ngIf="item.ColValues[data].Object == 122"
              (click)="openApproval(item.ColValues[data].ObjectKey)"
            >
              {{ item.ColValues[data].Value }}
            </a>
            <a
              *ngIf="item.ColValues[data].Object == 112"
              (click)="openDraftDocument(item.ColValues[data].ObjectKey , true)"
            >
              {{ item.ColValues[data].Value }}
            </a>
            <span
              *ngIf="
                item.ColValues[data].Object != 122 &&
                item.ColValues[data].Object != 112
              "
            >
              {{ item.ColValues[data].Value }}
            </span>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>

  <!-- END -->
</div>
<nz-skeleton
  [nzActive]="true"
  *ngIf="isLoading"
  style="margin: 1% 1%"
></nz-skeleton>

<ng-template #ApprovaldrawerTemplate let-drawerRef="drawerRef">
  <form nz-form [formGroup]="approvalForm" (ngSubmit)="onApprovalSubmit()">
    <nz-divider nzText="Authorization Details"></nz-divider>
    <nz-form-item>
      <nz-form-label> User </nz-form-label>
      <nz-form-control>
        <input
          type="text"
          disabled
          nz-input
          value="{{ ApprovalMessage.Requester }}"
        />
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label> Remarks </nz-form-label>
      <nz-form-control>
        <input
          type="text"
          disabled
          nz-input
          value="{{ ApprovalMessage.Remarks }}"
        />
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label> Template </nz-form-label>
      <nz-form-control>
        <input
          type="text"
          disabled
          nz-input
          value="{{ ApprovalMessage.TemplateName }} <{{
            ApprovalMessage.TemplateRemark
          }}>"
        />
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label> Stage </nz-form-label>
      <nz-form-control>
        <input
          type="text"
          disabled
          nz-input
          value="{{ ApprovalMessage.StageName }}"
        />
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label> Document Number </nz-form-label>
      <nz-form-control>
        <nz-button-group>
          <a
            nz-button
            nzType="link"
            (click)="openDraftDocument(ApprovalMessage.DocEntry)"
            >{{ ApprovalMessage.DocNum }}</a
          >
        </nz-button-group>
      </nz-form-control>
    </nz-form-item>
    <nz-divider nzText="Answer"></nz-divider>
    <nz-form-item>
      <nz-form-label> Decision </nz-form-label>
      <nz-form-control>
        <nz-select formControlName="AppStatus">
          <nz-option nzValue="W" nzLabel="Pending"></nz-option>
          <nz-option nzValue="Y" nzLabel="Approve"></nz-option>
          <nz-option nzValue="N" nzLabel="Not Approved"></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label> Remarks </nz-form-label>
      <nz-form-control>
        <input type="text" nz-input formControlName="AppRemark" />
      </nz-form-control>
    </nz-form-item>
    <button
      nz-button
      type="submit"
      nzType="primary"
      (click)="drawerRef.close()"
    >
      Update Decision
    </button>
    <button
      nz-button
      type="button"
      nzType="default"
      (click)="drawerRef.close()"
    >
      close
    </button>
  </form>
</ng-template>
